import React from 'react';
import {
	MenuItem,
	InputLabel,
	FormControl,
	Select,
	SelectProps,
	SelectChangeEvent,
} from '@mui/material';
import { ISelectOption } from 'components/base/model/ISelect';

interface MuiCustomSelectProps extends SelectProps {
	options?: ISelectOption[] | null;
	selectClassName?: string;
	onSelectChange?: (v: unknown) => void;
	label?: string;
	name: string;
	id: string;
	variant?: 'standard' | 'outlined' | 'filled';
	value?: string | number;
	disabled?: boolean;
}

export const MuiCustomSelect = ({
	options,
	label = '',
	selectClassName,
	onSelectChange,
	value = '',
	variant = 'outlined',
	disabled = false,
	...props
}: MuiCustomSelectProps) => {
	const selectValue = (e: SelectChangeEvent<unknown>) =>
		onSelectChange && onSelectChange(e.target.value);

	return (
		<FormControl variant={variant} className={selectClassName}>
			<InputLabel id="select-label">{label}</InputLabel>
			<Select
				label={label}
				MenuProps={{
					anchorOrigin: {
						vertical: 'bottom',
						horizontal: 'center',
					},
					transformOrigin: {
						vertical: 'top',
						horizontal: 'center',
					},
				}}
				onChange={selectValue}
				value={value}
				disabled={disabled}
				{...props}
			>
				{options?.map(({ title, value: optionValue }) => (
					<MenuItem value={optionValue} key={optionValue} qa-type="list-option">
						{title}
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
};
